const ServiceCategory = ({ sub_skill, current_status = null }) => {
    if (!sub_skill) return null;

    const {
        sub_skill_name,
        skill = {},
    } = sub_skill;

    const {
        skill_name,
        skill_web_app_icon,
    } = skill;

    return (
        <div className="bg-gradient-dark shadow-dark border-radius-lg py-3 pe-1">
            <div className="container">
                <div className="row">
                    <div className="col-8 my-auto">
                        <div className="numbers">
                            <p className="text-white text-sm mb-0 text-capitalize font-weight-bold opacity-7">{skill_name}</p>
                            <h5 className="text-white font-weight-bolder mb-0">
                                {sub_skill_name}
                            </h5>
                        </div>
                    </div>
                    <div className="col-4 text-end">
                        <i
                            className="material-icons opacity-10 text-white"
                            style={{ fontSize: 50 }}
                            aria-hidden="true"
                        >
                            {skill_web_app_icon}
                        </i>
                    </div>
                    {/* {current_status && <h5 className="mb-0 text-white text-end me-3">{current_status?.job_status_name}</h5>} */}
                </div>
            </div>
        </div>
    );
};

export default ServiceCategory;